module.exports = "<ul>\n    <li *ngFor=\"let item of items | async\">\n        {{ item.message }}\n    </li>\n</ul>\n"